import { useCallback, useState } from 'react';

type EmptyCallback = () => void;

export const useToggle = (
  initialValue = false,
): [boolean, EmptyCallback, EmptyCallback, EmptyCallback] => {
  const [value, setValue] = useState(initialValue);

  const toggle = useCallback(() => setValue((prev) => !prev), []);
  const on = useCallback(() => setValue(true), []);
  const off = useCallback(() => setValue(false), []);

  return [value, toggle, on, off];
};
